
import { useState } from 'react';

export default function Hero() {
  const [showSocial, setShowSocial] = useState(false);
  const [ripples, setRipples] = useState<Array<{ id: number; x: number; y: number }>>([]);

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setShowSocial(!showSocial);
    
    // Create ripple effect
    const button = e.currentTarget;
    const rect = button.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    const newRipple = { id: Date.now(), x, y };
    setRipples(prev => [...prev, newRipple]);
    
    // Remove ripple after animation
    setTimeout(() => {
      setRipples(prev => prev.filter(ripple => ripple.id !== newRipple.id));
    }, 600);
  };

  return (
    <section id="home" className="min-h-screen flex items-center bg-gradient-to-br from-blue-50 to-white pt-20">
      <div className="max-w-7xl mx-auto px-6 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 order-2 lg:order-1">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Bonjour,<br />
              <span className="text-blue-600">Je suis Foued Hassin</span><br />
              <span className="text-3xl lg:text-4xl text-gray-700">Ceci est mon CV</span>
            </h1>
            <a
              href="mailto:fouedhessin@gmail.com"
              className="inline-block px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contacter
            </a>
          </div>

          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative">
              <div className="w-80 h-80 rounded-full overflow-hidden border-8 border-white shadow-2xl">
                <img
                  src="https://justenjay1234.github.io/fouedieua/foued.jpg"
                  alt="Foued Hessin"
                  title="Foued Hessin"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-20 right-4 sm:right-0 sm:-right-4">
                <button
                  onClick={handleButtonClick}
                  className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-full hover:bg-blue-700 hover:scale-110 active:scale-95 transition-all shadow-xl cursor-pointer z-20 relative overflow-hidden"
                  title={showSocial ? "Hide social links" : "Show social links"}
                >
                  <i className={`${showSocial ? 'ri-close-line' : 'ri-links-line'} text-xl transition-transform ${showSocial ? 'rotate-90' : ''}`}></i>
                  
                  {ripples.map(ripple => (
                    <span
                      key={ripple.id}
                      className="absolute rounded-full bg-white/40 pointer-events-none animate-ripple"
                      style={{
                        left: ripple.x,
                        top: ripple.y,
                        width: '10px',
                        height: '10px',
                        transform: 'translate(-50%, -50%)',
                      }}
                    />
                  ))}
                </button>
                
                <div className={`absolute bottom-14 right-0 flex flex-col gap-2 bg-white p-3 rounded-2xl shadow-xl transition-all duration-300 ${showSocial ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-4 pointer-events-none'}`}>
                  <a href="https://www.instagram.com/foued.hassin.officiel/" title="Instagram" className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-purple-600 to-pink-500 text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a href="https://www.linkedin.com/in/foued-hassin-36250921b" title="LinkedIn" className="w-10 h-10 flex items-center justify-center bg-blue-700 text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-linkedin-box-fill text-lg"></i>
                  </a>
                  <a href="https://www.facebook.com/fouedhassin1996" title="Facebook" className="w-10 h-10 flex items-center justify-center bg-blue-600 text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-facebook-box-fill text-lg"></i>
                  </a>
                  <a href="https://x.com/fouedhassin" title="Twitter" className="w-10 h-10 flex items-center justify-center bg-black text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-twitter-x-fill text-lg"></i>
                  </a>
                  <a href="https://www.tiktok.com/@foued.hassin.official" title="TikTok" className="w-10 h-10 flex items-center justify-center bg-black text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-tiktok-fill text-lg"></i>
                  </a>
                  <a href="https://wa.me/21919013" title="WhatsApp" className="w-10 h-10 flex items-center justify-center bg-green-500 text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-whatsapp-fill text-lg"></i>
                  </a>
                  <a href="mailto:fouedhessin@gmail.com" title="Email" className="w-10 h-10 flex items-center justify-center bg-red-500 text-white rounded-lg hover:scale-110 active:scale-95 transition-transform cursor-pointer">
                    <i className="ri-mail-fill text-lg"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
